import cloneDeep from 'lodash/cloneDeep'
import demoNeedsEn from './demoNeedsEn.json'
import demoNeedsEnExtras from './demoNeedsEnExtras.json'

const LOOKUP = { ...demoNeedsEn, ...demoNeedsEnExtras }

/** valores de colunas tipo/status em telas fictícias */
const ENUM_EN = {
  lido: 'read',
  novo: 'new',
  entregue: 'delivered',
  texto: 'text',
  áudio: 'audio',
  documento: 'document',
  imagem: 'image',
  link: 'link',
  story: 'story',
  post: 'post',
  bot: 'bot',
  snap: 'snap',
  sistema: 'system',
  aberto: 'opened',
  vídeo: 'video'
}

export function normalizeDemoLocale(locale) {
  return locale === 'en' ? 'en' : 'pt'
}

function translateLeafString(str) {
  if (typeof str !== 'string') return str
  if (Object.prototype.hasOwnProperty.call(LOOKUP, str)) return LOOKUP[str]
  if (Object.prototype.hasOwnProperty.call(ENUM_EN, str)) return ENUM_EN[str]
  let s = str.replace(/\(demonstração\)/g, '(demo)')
  if (/^painel\s+\(demo\)$/i.test(s)) s = 'Panel (demo)'
  s = s.replace(/\bOntem\b/g, 'Yesterday')
  return s
}

function walk(value) {
  if (typeof value === 'string') return translateLeafString(value)
  if (Array.isArray(value)) return value.map(walk)
  if (value && typeof value === 'object') {
    const next = {}
    Object.keys(value).forEach((k) => {
      next[k] = walk(value[k])
    })
    return next
  }
  return value
}

/**
 * Traduz dados fictícios da demo quando locale === 'en'.
 * @param {object} data
 * @param {string} [locale]
 */
export function localizeDemoRich(data, locale) {
  if (normalizeDemoLocale(locale) !== 'en') return data
  return walk(cloneDeep(data))
}
